<template>
  <div class="modal product-modal">
    <div class="overlay" @click="closeModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img class="close" @click="closeModal" src="@/images/close.svg" />
            <div class="product-modal-top">
              <div class="text-container">
                <div class="text">
                  <!-- Step 1: Contact Information -->
                  <div v-if="step === 1">
                    <div class="title">{{ $t("CONTACT INFORMATION") }}</div>
                    <div class="form-fields-wrapper">
                      <div class="input-container">
                        <div class="desc">{{ $t("Name") }}</div>
                        <input type="text" v-model="name" />
                      </div>
                      <div class="input-container">
                        <div class="desc">{{ $t("Surname") }}</div>
                        <input type="text" v-model="surname" />
                      </div>
                      <div class="input-container">
                        <div class="desc">{{ $t("E-mail address") }}</div>
                        <input type="email" v-model="email" />
                      </div>
                      <div class="input-container">
                        <div class="desc">{{ $t("Phone") }}</div>
                        <input type="text" v-model="phone" />
                      </div>
                      <div class="input-container">
                        <div class="desc">{{ $t("Country") }}</div>
                        <select v-model="country" :class="{ empty: !country }">
                          <option value="" disabled selected>
                            {{ $t("Country") }}
                          </option>
                          <option
                            v-for="item in countryOptions"
                            :value="item"
                            :key="item.id"
                          >
                            {{ item.title }}
                          </option>
                        </select>
                      </div>
                      <div class="input-container">
                        <div class="desc">{{ $t("City") }}</div>
                        <input type="text" v-model="city" />
                      </div>
                      <div class="input-container">
                        <div class="desc">{{ $t("Address") }}</div>
                        <input type="text" v-model="address" />
                      </div>
                      <div class="input-container">
                        <div class="desc">{{ $t("Post Code") }}</div>
                        <input type="text" v-model="postCode" />
                      </div>
                    </div>
                    <div class="buttons">
                      <button
                        class="button"
                        :disabled="isLoading"
                        @click="goToIbanStep"
                      >
                        {{ $t("IBAN") }}
                      </button>
                      <button
                        class="button dark"
                        :disabled="isLoading"
                        @click="payoutWithCard"
                      >
                        <span v-if="!isLoading">{{ $t("Card") }}</span>
                        <Spinner v-else />
                      </button>
                    </div>
                  </div>

                  <!-- Step 2: IBAN Details -->
                  <div v-if="step === 2">
                    <div class="title">{{ $t("IBAN TRANSFER") }}</div>
                    <div class="form-fields-wrapper single-column">
                      <div class="input-container">
                        <div class="desc">{{ $t("First Name") }}</div>
                        <input type="text" v-model="bank_holder_name" />
                      </div>
                      <div class="input-container">
                        <div class="desc">{{ $t("Last Name") }}</div>
                        <input type="text" v-model="bank_holder_surname" />
                      </div>
                      <div class="input-container">
                        <div class="desc">{{ $t("IBAN") }}</div>
                        <input
                          type="text"
                          v-model="iban_number"
                          maxlength="34"
                        />
                      </div>
                    </div>
                    <div class="chekbox-container">
                      <label class="chekbox-label">
                        <div class="chekbox-label-wrapper">
                          <input v-model="terms" type="checkbox" name="terms" />
                          <div class="checkbox" />
                          <span class="title">{{ $t("I agree with") }} </span>
                          <a class="title">
                            {{ $t("privacy policy") }}
                          </a>
                          <span class="title"> {{ $t("and") }} </span>
                          <a class="title">
                            {{ $t("terms and conditions") }}
                          </a>
                        </div>
                      </label>
                    </div>
                    <div class="buttons">
                      <button class="button dark" @click="step = 1" :disabled="isLoading">
                        {{ $t("Back") }}
                      </button>
                      <button
                        class="button"
                        :disabled="isLoading"
                        @click="confirmIbanPayout"
                      >
                        <span v-if="!isLoading">{{ $t("Confirm") }}</span>
                        <Spinner v-else />
                      </button>
                    </div>
                  </div>

                  <!-- Step 3: Success Message -->
                  <div v-if="step === 3">
                    <div class="title">{{ $t("PAYOUT SUCCESSFUL") }}</div>
                    <div class="success-message-container">
                      <div class="success-icon">✓</div>
                      <div class="success-text">
                        {{ successMessage }}
                      </div>
                    </div>
                    <div class="buttons">
                      <button class="button dark" @click="closeModal">
                        {{ $t("Close") }}
                      </button>
                    </div>
                  </div>

                  <transition name="slide">
                    <div v-if="formError" class="error-desc desc red error-box">
                      {{ formError }}
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Spinner from "@/components/shared/Spinner.vue";

export default {
  name: "AcceptOfferModal",
  props: {
    orderToView: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  components: {
    Spinner,
  },
  data() {
    return {
      step: 1,
      name: "",
      surname: "",
      email: "",
      phone: "",
      country: "",
      city: "",
      address: "",
      postCode: "",
      iban_number: "",
      bank_holder_name: "",
      bank_holder_surname: "",
      terms: false,
      formError: "",
      isLoading: false,
      countryOptions: [],
      successMessage: "",
      showSuccess: false,
    };
  },
  computed: {
    isContactInfoValid() {
      return (
        this.name &&
        this.surname &&
        this.email &&
        this.phone &&
        this.country &&
        this.city &&
        this.address &&
        this.postCode
      );
    },
    isIbanFormValid() {
      return (
        this.bank_holder_name &&
        this.bank_holder_surname &&
        this.iban_number &&
        this.terms
      );
    },
  },
  methods: {
    ...mapActions("modals", ["closeAcceptOfferModal"]),
    ...mapActions("offer", [
      "requestPayoutCard",
      "requestPayoutIban",
      "getOfferHistory",
    ]),
    getCountries() {
      this.$http
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          this.countryOptions = res.data.payload;
        })
        .catch((err) => {
          this.formError = "Could not load countries.";
        });
    },
    closeModal() {
      this.closeAcceptOfferModal();
      this.resetForm();
    },
    closeModalAndRefresh() {
      this.getOfferHistory();
      this.closeModal();
    },
    resetForm() {
      this.step = 1;
      this.formError = "";
      this.successMessage = "";
      this.showSuccess = false;
      this.isLoading = false;
      this.bank_holder_name = "";
      this.bank_holder_surname = "";
      this.iban_number = "";
      this.terms = false;
      if (this.user) {
        this.name = this.user.name || "";
        this.surname = this.user.surname || "";
        this.email = this.user.email || "";
        this.phone = this.user.phone || "";
      }
      this.country = "";
      this.city = "";
      this.address = "";
      this.postCode = "";
    },
    getContactInfoPayload() {
      if (!this.orderToView || !this.orderToView.id) {
        this.formError = "Invalid offer data. Missing offer ID.";
        return null;
      }

      return {
        id: this.orderToView.id,
        currency: this.orderToView.currency || "EUR",
        name: this.name,
        surname: this.surname,
        email: this.email,
        phone: this.phone,
        country:
          (this.country && this.country.title) ||
          (this.country && this.country.id) ||
          this.country,
        city: this.city,
        address: this.address,
        postCode: this.postCode,
      };
    },
    async payoutWithCard() {
      this.formError = "";
      if (!this.isContactInfoValid) {
        this.formError = "Please fill in all contact fields.";
        return;
      }

      const contactData = this.getContactInfoPayload();
      if (!contactData) return;

      this.isLoading = true;
      try {
        const response = await this.requestPayoutCard(contactData);
        if (response && response.redirect_url) {
          window.location.href = response.redirect_url;
        } else {
          this.handleApiError("Could not retrieve payment URL. Please try again.");
        }
      } catch (error) {
        this.handleApiError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async confirmIbanPayout() {
      this.formError = "";
      if (!this.isIbanFormValid) {
        this.formError = "Please fill in all IBAN fields and accept the terms.";
        return;
      }

      if (
        !/^[A-Z]{2}[0-9]{2}[A-Z0-9]{4,30}$/.test(
          this.iban_number.replace(/\s+/g, "")
        )
      ) {
        this.formError = "Please enter a valid IBAN.";
        return;
      }

      if (!this.orderToView || !this.orderToView.id) {
        this.formError = "Invalid offer data. Missing offer ID.";
        return;
      }

      const payoutData = {
        id: this.orderToView.id,
        currency: this.orderToView.currency || "EUR",
        first_name: this.bank_holder_name,
        last_name: this.bank_holder_surname,
        account_number: this.iban_number,
      };

      this.isLoading = true;
      try {
        const response = await this.requestPayoutIban(payoutData);
        if (response && response.status === "OK") {
          // Show success message within the modal
          this.successMessage = "Your payout request has been successfully submitted. Your funds will be transferred to your bank account soon.";
          this.step = 3;
          this.formError = "";
        } else {
          this.handleApiError((response && response.message) || "An error occurred while processing your request.");
        }
      } catch (error) {
        this.handleApiError(error);
      } finally {
        this.isLoading = false;
      }
    },
    goToIbanStep() {
      this.formError = "";
      if (!this.isContactInfoValid) {
        this.formError = "Please fill in all contact fields.";
        return;
      }
      this.step = 2;
    },
    handleApiError(error) {
      console.error('AcceptOfferModal error:', error);
      
      // Reset loading state immediately
      this.isLoading = false;
      
      if (error && typeof error === "object") {
        if (error.errors) {
          // Handle field-specific errors
          let errorMessages = [];
          Object.keys(error.errors).forEach((field) => {
            if (Array.isArray(error.errors[field])) {
              errorMessages = errorMessages.concat(error.errors[field]);
            } else {
              errorMessages.push(error.errors[field]);
            }
          });

          if (errorMessages.length > 0) {
            this.formError = errorMessages.join(", ");
            return;
          }
        }

        if (error.message) {
          this.formError = error.message;
          return;
        }
      }

      // Fallback for string errors or unknown format
      const errorMessage = typeof error === "string" ? error : "Something went wrong";
      this.formError = errorMessage;
    },
  },
  mounted() {
    this.getCountries();
    this.resetForm();
  },
  watch: {
    orderToView(newVal) {
      if (newVal) {
        this.resetForm();
      }
    },
    user() {
      this.resetForm();
    },
  },
};
</script>

<style scoped>
.product-modal .wrapper .text-container {
  padding-top: 60px;
}
.form-fields-wrapper.single-column {
  grid-template-columns: 1fr;
  max-width: 300px;
  margin: 0 auto;
}
.i-have-read-and-block {
  margin-top: 36px;
}
.success-text {
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 24px;
}
.error-box {
  color: #ff7c7c;
  margin-top: 16px;
}
.product-modal .wrapper .buttons {
  justify-content: center;
}
.chekbox-container {
  display: flex;
  justify-content: center;
  color: #fff;
}
.chekbox-label .title {
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 22px;
}
.chekbox-label a.title {
  font-weight: 700 !important;
}

.success-message-container {
  text-align: center;
  padding: 40px 20px;
}

.success-icon {
  font-size: 48px;
  color: #28a745;
  background-color: rgba(40, 167, 69, 0.1);
  border: 2px solid #28a745;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  font-weight: bold;
}

.success-text {
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
  max-width: 400px;
  margin: 0 auto;
}
</style>
